// Moved unchanged out of CaseBriefPage.js (ticket 072). Old brief only: the list of the client's
// saved Calculator runs.
import React from 'react'
import { formatEuro } from '../../../lib/briefUtils'
import { getAdvisorSessionStateLabel } from '../../HomeLink'
import { formatDate } from '../../../lib/briefFormat'
import { SourceCardHeader } from './BriefParts'

export function ScenariosCard({ sessions, viewedSessionId, onSelect, loading }) {
  if (!sessions || sessions.length <= 1) return null
  const defaultId = sessions[0]?.id
  const activeId = viewedSessionId || defaultId

  return (
    <div className="brief-source-card">
      <SourceCardHeader title={`Scenarios (${sessions.length})`} />
      <div className="brief-source-card-body">
        <div className="brief-scenarios-list">
          {sessions.map(s => {
            const isActive  = s.id === activeId
            const isDefault = s.id === defaultId
            return (
              <div key={s.id} className={`brief-scenario-row${isActive ? ' active' : ''}`}>
                <div>
                  <div className="u-label-base">
                    {s.is_autonomo ? 'Autónomo' : 'IRPF'} · {s.tax_year}
                    {isDefault && <span className="brief-scenario-default-tag">Default</span>}
                  </div>
                  <div className="u-name-sub">
                    {formatEuro(s.irpf_gross)} ·{' '}
                    {s.is_draft
                      ? <span className="brief-scenario-draft-tag">{getAdvisorSessionStateLabel('draft')}, not published · last edited {formatDate(s.updated_at)}</span>
                      : <>{getAdvisorSessionStateLabel('published')} {formatDate(s.published_at)}</>}
                  </div>
                  {!s.is_draft && s.public_token && (
                    <a
                      href={`/calculator/result/${s.public_token}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="u-text-link"
                    >
                      View as client saw it ↗
                    </a>
                  )}
                </div>
                <button
                  className="brief-scenario-view-btn"
                  onClick={() => onSelect(isDefault ? null : s.id)}
                  disabled={loading || isActive}
                >
                  {isActive ? '✓ Viewing this' : 'View scenario →'}
                </button>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
